export default "__VITE_ASSET__8ccb8be8__"